import React from 'react';
import { useTranslation } from 'react-i18next';

import PanelCard from '../../performance-operations/components/PanelCard';
import { KpiSub, KpiValue } from '../../performance-operations/styles';
import { formatNumber, hasValue, metricOf } from '../../performance-operations/config';

// Analiz E09 üst alan — M29 9-Box kapsaması, M30 yüksek potansiyel, M31 yüksek/yüksek hücresi, M32 hazır yedek kapsaması.
// Her kart değer + pay/payda gösterir; payda 0 → "Veri Yok"; küçük grup gizliyse neden. Potansiyel erişimi yoksa M30/M31 gelmez;
// yedekleme (izlenen kritik pozisyon) yoksa M32 kaldırılır.
export function MetricCard({ code, title, metric, sub, loading, error, onRetry, threshold }) {
  const { t, i18n } = useTranslation();
  let value;
  if (metric?.suppressionReason) value = t('talent.nineBoxTransitions.kpi.suppressed');
  else if (!hasValue(metric)) value = t('performance.operations.kpi.noData');
  else value = `${formatNumber(metric.value, i18n.language)}%`;
  const ratio = hasValue(metric) && metric.numerator != null && metric.denominator != null
    ? t('performance.operations.kpi.ratio', { num: formatNumber(metric.numerator, i18n.language, 0), den: formatNumber(metric.denominator, i18n.language, 0) })
    : null;
  return (
    <PanelCard panelKey={`kpi-${code}`} title={title} span={3} kpi compact loading={loading} error={error} onRetry={onRetry}>
      <KpiValue data-kpi={code}>{value}</KpiValue>
      {ratio ? <KpiSub>{ratio}</KpiSub> : null}
      {metric?.suppressionReason ? <KpiSub data-note="suppressed">{t('talent.nineBoxTransitions.kpi.suppressedHint', { k: threshold })}</KpiSub> : null}
      {sub ? <KpiSub>{sub}</KpiSub> : null}
    </PanelCard>
  );
}

export default function NineBoxKpis({ panel }) {
  const { t } = useTranslation();
  const data = panel.data;
  const common = { loading: panel.loading, error: panel.error, onRetry: panel.retry, threshold: data?.threshold };
  const noProcess = data && !data.process;
  const visible = data ? data.potentialVisible : true;
  return (
    <>
      <MetricCard
        code="M29" title={t('talent.nineBoxTransitions.kpi.coverage')} metric={metricOf(data?.metrics, 'M29')}
        sub={noProcess ? t('talent.nineBoxTransitions.noProcess') : t('talent.nineBoxTransitions.kpi.coverageSub')} {...common}
      />
      {visible ? (
        <MetricCard
          code="M30" title={t('talent.nineBoxTransitions.kpi.highPotential')} metric={metricOf(data?.metrics, 'M30')}
          sub={t('talent.nineBoxTransitions.kpi.highPotentialSub')} {...common}
        />
      ) : null}
      {visible ? (
        <MetricCard
          code="M31" title={t('talent.nineBoxTransitions.kpi.star')} metric={metricOf(data?.metrics, 'M31')}
          sub={t('talent.nineBoxTransitions.kpi.starSub')} {...common}
        />
      ) : null}
      {!data || data.successionActive ? (
        <MetricCard
          code="M32" title={t('talent.nineBoxTransitions.kpi.readySuccessor')} metric={metricOf(data?.metrics, 'M32')}
          sub={t('talent.nineBoxTransitions.kpi.readySuccessorSub')} {...common}
        />
      ) : null}
    </>
  );
}
